import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { tutorialRepository } from '../data-access/repositories/TutorialRepository'

const base = ['tutorial']

export const tutorialQueryConfig = {
  status: () => ({
    queryKey: buildQueryKey([...base, 'status']),
    queryFn: () => tutorialRepository.getTutorialStatus(),
    staleTime: Infinity, // bootstrap-preference parity — changes only via dismiss
  }),
}
